import { IUser } from '@/pages/Users/users.types.ts'
import SeparateLine from '@/shared/Forms/SeparateLine'
import css from '../userSidePage.module.css'
import timeUtils from '@/utils/time.utils.ts'
import FormEditButton from '@/shared/Buttons/FormEditButton'
import FormDeleteButton from '@/shared/Buttons/FormDeleteButton'
import confirmService from '@/services/ConfirmService/confirm.service.ts'
import usersApi from '@/pages/Users/users.api.ts'
import usersEvents from '@/pages/Users/events/users.events.ts'
import Tag from '@/shared/Tags/Tag'
import ProtectedContent from '@/services/rights/ProtectedContent'
import userUtils from '@/pages/User/user.utils.ts'
import UserAdminRoutesHistoryTable from '@/pages/Users/components/UserSidePage/UserAdminRoutesHistoryTable'

interface IProps {
  onClose: () => void
  onEdit: () => void
  user: IUser
}

const ViewUserSidePageContent = (props: IProps) => {
  const handleRemove = () => {
    confirmService.requestConfirm({
      description: `Подтвердите удаление сотрудника:\n${userUtils.getFullName(props.user.userInfo)}`,
      buttonType: 'primary',
      onConfirm: () =>
        usersApi
          .remove(props.user.id)
          .then((r) => r.status === 'success' && usersEvents.deleted(r.body.id))
          .then(() => props.onClose()),
    })
  }

  return (
    <div className="flex-lines gap16 height100" style={{ minHeight: 0 }}>
      <div className={css.headerRow}>
        <h4 className={`text-heading-4 ${css.headerTitle}`}>{userUtils.getFullName(props.user.userInfo)}</h4>
        {props.user.active ? (
          <div className={css.headerStatus}>
            <Tag color="green">Активен</Tag>
          </div>
        ) : (
          <div className={css.headerStatus}>
            <Tag color="red">Деактивирован</Tag>
          </div>
        )}
      </div>
      <SeparateLine />
      <div className={css.sidePageGrid}>
        <p className="text-nm text-secondary">Дата добавления:</p>
        <p className="text-nm">{timeUtils.formatDate(new Date(props.user.createdAt), 'dd MMM yyyy, HH:mm')}</p>
        <p className="text-nm text-secondary">Логин:</p>
        <p className="text-nm">{props.user.login}</p>
        <p className="text-nm text-secondary">Email:</p>
        <p className="text-nm">{props.user.email || '-'}</p>
        <p className="text-nm text-secondary">Номер телефона:</p>
        <p className="text-nm">{props.user.userInfo.phoneNumber || '-'}</p>
        <p className="text-nm text-secondary">Должность:</p>
        <p className="text-nm">{props.user.position || '-'}</p>
      </div>
      <SeparateLine />
      <div className={css.routesHistoryBlock}>
        <h5 className="text-heading-5">История переходов</h5>
        <UserAdminRoutesHistoryTable userId={props.user.id} />
      </div>
      <ProtectedContent requiredOneOf={['users:update', 'users:delete']}>
        <SeparateLine />
        <div className="inline-flex-gap gap8">
          <ProtectedContent requiredRight="users:update">
            <FormEditButton onClick={props.onEdit} />
          </ProtectedContent>
          <ProtectedContent requiredRight="users:delete">
            <FormDeleteButton onClick={handleRemove} />
          </ProtectedContent>
        </div>
      </ProtectedContent>
    </div>
  )
}

export default ViewUserSidePageContent
